//import React from 'react';

const Services = () => {
  return (
    <div>
      <h2>Our Services</h2>
      <ul>
        <li>Custom Software Development</li>
        <li>Cloud Integration</li>
        <li>Consulting and Support</li>
      </ul>
    </div>
  );
};

export default Services;